/*
 * Override the PageGridRow cascade (`* { grid-column: 1 / -1 }`) that OnboardingLayout applies.
 * Double-class specificity (0,2,0) beats PageGridRow's single-class rule (0,1,0).
 */
.connectionGroup.connectionGroup * {
  grid-column: auto;
}
